<template>
  <div class="snackbar-container">
    <v-snackbar 
      v-for="(snackbar, index) in snackbarStore.snackbars" 
      :key="snackbar.id" 
      v-model="snackbar.isVisible" 
      :color="snackbar.color" 
      :timeout="snackbar.timeout" 
      location="bottom start"
      :style="{ bottom: (index * 60) + 'px' }"
      @update:model-value="() => snackbarStore.remove(snackbar.id)"
    >
      <span>{{ snackbar.text }}</span>
      <template v-slot:actions>
        <v-btn 
          icon 
          color="white" 
          variant="text" 
          @click="snackbarStore.remove(snackbar.id)" 
          density="compact"
        >
          <v-icon size="large">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup>
import { useSnackbarStore } from "@/ai_studio/stores/snackbar";
const snackbarStore = useSnackbarStore();
</script>

<style scoped>
.snackbar-container {
  position: absolute;
  width: fit-content;
  height: 100vh;
  top: 0;
  left: 0;
}
</style>